import { render } from "./admin-modal.vue?vue&type=template&id=651a8099"
import script from "./admin-modal.vue?vue&type=script&lang=js"
export * from "./admin-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__